class LocalizationForm extends HTMLElement {
	constructor() {
		super();
		this.elements = {
			input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
			button: this.querySelector('button'),
			panel: this.querySelector('ul'),
		};
		
		// L'input est requis pour l'interception ; le bouton/panel sont optionnels
		// (absents quand le form est rendu dans la modale de localisation).
		if (!this.elements.input) {
			console.warn('LocalizationForm: hidden input not found');
			return;
		}

		if (this.elements.button && this.elements.panel) {
			this.elements.button.addEventListener('click', this.openSelector.bind(this));
			this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
			this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
		}

		// Options obfusquees : <span role="link" data-href> et non <a href> (SEO, ClickUp 86caz0bb2).
		// On restitue au clavier ce que le <a> offrait nativement : Enter et Espace activent l'option.
		this.querySelectorAll('[data-href]').forEach((item) => {
			item.addEventListener('click', this.onItemClick.bind(this));
			item.addEventListener('keydown', (event) => {
				if (event.key !== 'Enter' && event.key !== ' ') return;
				event.preventDefault();
				this.onItemClick(event);
			});
		});
	}

	hidePanel() {
		if (!this.elements.button || !this.elements.panel) return;
		
		this.elements.button.setAttribute('aria-expanded', 'false');
		this.elements.panel.setAttribute('hidden', true);
	}

	onContainerKeyUp(event) {
		if (event.code.toUpperCase() !== 'ESCAPE') return;

		this.hidePanel();
		this.elements.button?.focus();
	}

	onItemClick(event) {
		event.preventDefault();
		const form = this.querySelector('form');
		const value = event.currentTarget?.dataset?.value;

		if (!value || !this.elements.input) return;

		this.elements.input.value = value;

		// {% form 'localization' %} injecte un return_to = path COURANT. Sans ecrasement,
		// Shopify applique le market puis renvoie sur la page courante non localisee
		// (d'ou le "il faut cliquer deux fois"). On force la destination de l'option.
		const href = event.currentTarget.getAttribute('data-href');
		const returnTo = form?.querySelector('input[name="return_to"]');
		if (returnTo && href) returnTo.value = href;

		if (form) form.submit();
	}

	openSelector() {
		if (!this.elements.button || !this.elements.panel) return;
		
		this.elements.button.focus();
		const isExpanded = this.elements.button.getAttribute('aria-expanded') === 'true';
		
		if (isExpanded) {
			this.hidePanel();
		} else {
			this.elements.panel.removeAttribute('hidden');
			this.elements.button.setAttribute('aria-expanded', 'true');
		}
	}

	closeSelector(event) {
		if (!event.relatedTarget || !this.contains(event.relatedTarget)) {
			this.hidePanel();
		}
	}
}

customElements.define('localization-form', LocalizationForm);
